'use strict';

define('composer/uploads', [
	'spark-md5',
	'alerts',
	'composer/drag',
	'jquery-form',
], function (SparkMD5, alerts, drag) {
	const CHUNK_SIZE = 1024 * 1024 * 5; // 5MB
	const MAX_VIDEO_DURATION = 60;

	function loadNextChunk(file, fileReader, blobSlice, currentChunk) {
		const start = currentChunk * CHUNK_SIZE;
		let end = start + CHUNK_SIZE;
		if (end > file.size) {
			end = file.size;
		}
		fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
	}
	const getMD5 = file => new Promise((resolve) => {
		try {
			const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
			const chunks = Math.ceil(file.size / CHUNK_SIZE);
			let currentChunk = 0;
			const spark = new SparkMD5.ArrayBuffer();
			const fileReader = new FileReader();

			fileReader.onload = function (e) {
				spark.append(e.target.result);
				currentChunk += 1;
				if (currentChunk < chunks) {
					loadNextChunk(file, fileReader, blobSlice, currentChunk);
				} else {
					const md5 = spark.end();
					resolve(md5);
				}
			};

			fileReader.onerror = function () {
				resolve();
			};

			loadNextChunk(file, fileReader, blobSlice, currentChunk);
		} catch (ex) {
			resolve();
		}
	});

	var uploads = {
		inProgress: {},
		queue: new Map(),
	};
	window.uploads = uploads;

	uploads.initialize = function (post_uuid, data, onComposerUploaded) {
		uploads.postData = data;
		uploads.onComposerUploaded = onComposerUploaded;
		addChangeHandlers(post_uuid);
	};

	const FileType = { Image: 1, Video: 2 };
	// png,jpg,bmp,mp4,quicktime
	const isImage = file => /^image\/(png|jpe?g|bmp)$/i.test(file.type);
	const isVideo = file => /^video\/(mp4|quicktime)$/i.test(file.type);

	const fetchImage = url => new Promise((resolve) => {
		const img = new Image();
		img.onload = () => {
			resolve({
				width: img.width,
				height: img.height,
			});
		};
		img.src = url;
	});

	const compressImageSize = (naturalWidth, naturalHeight) => {
		const aspectRatio = naturalWidth / naturalHeight;
		let width = Math.min(2532, naturalWidth);
		let height = Math.min(2532, naturalHeight);
		if (height * aspectRatio > width) {
			height = width / aspectRatio;
		} else {
			width = height * aspectRatio;
		}
		return {
			width,
			height,
		};
	};

	const canvas2Blob = (canvas, type) => new Promise((resolve) => {
		canvas.toBlob((blob) => {
			resolve(blob);
		}, type || 'image/jpeg', 0.8);
	});

	const loadImage = file => new Promise((resolve) => {
		const image = new Image();
		const url = URL.createObjectURL(file);
		image.onload = () => {
			const size = compressImageSize(image.naturalWidth, image.naturalHeight);
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');
			canvas.style.backgroundColor = 'white';
			canvas.width = size.width;
			canvas.height = size.height;
			ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
			canvas2Blob(ctx.canvas).then((blob) => {
				resolve({
					size,
					file: new File([blob], file.name.replace(/\.[^.]+$/i, '.jpg'), {
						type: 'image/jpeg',
					}),
				});
				URL.revokeObjectURL(url);
			});
		};
		image.src = url;
	});

	const loadVideo = (file, seekTo = 0.0) => new Promise((resolve, reject) => {
		const videoPlayer = document.createElement('video');
		videoPlayer.setAttribute('src', URL.createObjectURL(file));
		videoPlayer.load();
		videoPlayer.addEventListener('error', (ex) => {
			reject(new Error(ex));
		});
		videoPlayer.addEventListener('loadedmetadata', () => {
			if (videoPlayer.duration < seekTo) {
				reject(new Error('video is too short.'));
			}
			setTimeout(() => {
				videoPlayer.currentTime = seekTo;
			}, 200);
			videoPlayer.addEventListener('seeked', () => {
				const size = compressImageSize(videoPlayer.videoWidth, videoPlayer.videoHeight);
				const canvas = document.createElement('canvas');
				canvas.width = size.width;
				canvas.height = size.height;
				const ctx = canvas.getContext('2d');
				ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
				canvas2Blob(ctx.canvas).then((blob) => {
					resolve({
						duration: videoPlayer.duration,
						blob,
						size: {
							width: videoPlayer.videoWidth,
							height: videoPlayer.videoHeight,
						},
					});
				});
			});
		});
	});

	function addChangeHandlers(post_uuid) {
		var postContainer = $('.composer[data-uuid="' + post_uuid + '"]');

		postContainer.find('#files').on('change', async function (e) {
			const isForum = postContainer.attr('isforum') === 'true';
			const isMoment = postContainer.attr('ismoment') === 'true';
			const isReplay = postContainer.attr('isreplay') === 'true';
			const maxImageSize = parseInt(config.maximumFileSize, 10) * 1024;
			const files = (e.target || {}).files ||
				($(this).val() ? [{ name: $(this).val(), type: utils.fileMimeType($(this).val()) }] : null);
			const targetFileInfos = [];
			const tips = [];

			if (!files.length) { return; }

			// 先确定是论坛，是评论，是朋友圈？
			// 论坛图片最多20个，视频3个
			// 评论图片4个，
			// 朋友圈图片9个 或者 视频1个
			// 视频不能超过60s
			// 图片大小不能超过20M
			const originImageCount = postContainer.find(isForum ? '.ql-image' : '.img-item').length;
			const originVideoCount = postContainer.find(isForum ? '.ql-video' : 'video').length;
			let currentImageCount = 0;
			let currentVideoCount = 0;
			let limitType = isReplay ? FileType.Image : false;

			$('#uploadImage').prop('disabled', true).attr('disabled', true);

			const handleImageFile = file => loadImage(file).then(opt => getMD5(opt.file).then(md5 => ({
				file: opt.file,
				size: opt.size,
				isImage: true,
				md5,
			})));

			const handleVideoFile = file => loadVideo(file).then((params) => {
				const info = {
					file: file,
					isVideo: true,
					duration: params.duration,
				};
				if (params.blob) {
					info.cover = params.blob;
					info.size = params.size;
				}

				if (params.duration <= MAX_VIDEO_DURATION) {
					return getMD5(file).then((md5) => {
						info.md5 = md5;
						return info;
					});
				}
				return info;
			});

			const preload = [];
			for (let i = 0; i < files.length; i += 1) {
				const file = files[i];
				if (isVideo(file)) {
					preload.push(handleVideoFile(file));
				} else if (isImage(file)) {
					preload.push(handleImageFile(file));
				}
			}

			let fileInfos = [];
			try {
				fileInfos = await Promise.all(preload);
			} catch (ex) {}

			$('#uploadImage').prop('disabled', false).attr('disabled', false);

			if (!fileInfos || fileInfos.length === 0) { return; }

			for (let i = 0; i < fileInfos.length; i += 1) {
				const info = fileInfos[i];
				info.index = i;

				// 判断是否需要限制文件类型
				if (isMoment && !limitType) {
					if (isImage(info.file) || originImageCount) {
						limitType = FileType.Image;
					} else if (isVideo(info.file) || originVideoCount) {
						limitType = FileType.Video;
					}
				}

				if (isImage(info.file) && (!limitType || limitType === FileType.Image)) {
					if ((isForum && originImageCount + currentImageCount < 20) ||
						(isMoment && originImageCount + currentImageCount < 9) ||
						(isReplay && originImageCount + currentImageCount < 4)
					) {
						if (info.file.size <= maxImageSize) {
							targetFileInfos.push(info);
							// fd.append('files[]', file, file.name);
							currentImageCount += 1;
						} else {
							tips.push('[[error:file-too-big, ' + config.maximumFileSize + ']]');
						}
					} else {
						let count = 0;
						if (isForum) { count = 20; } else if (isMoment) { count = 9; } else if (isReplay) { count = 4; }
						tips.push(`You can only upload up to ${count} images.`);
					}
				} else if (isVideo(info.file) && (!limitType || limitType === FileType.Video)) {
					if ((isForum && originVideoCount + currentVideoCount < 3) ||
						(isMoment && originVideoCount + currentVideoCount < 1)
					) {
						if (info.duration <= MAX_VIDEO_DURATION) {
							targetFileInfos.push(info);
							// fd.append('files[]', file, file.name);
							currentVideoCount += 1;
						} else {
							tips.push(`Only supports uploading videos up to ${MAX_VIDEO_DURATION}s`);
						}
					} else if (isForum) {
						tips.push(`Only three video available.`);
					} else if (isMoment) {
						tips.push('Only one video available.');
					}
				} else if (!isVideo(info.file) && limitType === FileType.Video) {
					tips.push('Only video formats are supported.');
				} else if (!isImage(info.file) && limitType === FileType.Image) {
					tips.push('Only image formats are supported.');
				} else {
					tips.push('File type unavailable.');
				}
			}

			if (tips.length) {
				const msg = [];
				tips.forEach((i) => {
					if (msg.indexOf(i) === -1) {
						msg.push(i);
					}
				});
				app.alert({
					alert_id: 'action:composer.upload',
					title: '',
					message: msg.join(' '),
					timeout: 2000,
				});
			}

			if (targetFileInfos.length) {
				uploadContentFiles({
					limitType,
					fileInfos: targetFileInfos.sort((p1, p2) => p1.index - p2.index),
					post_uuid: post_uuid,
					route: '/api/post/upload',
					// formData: fd,
					isForum,
					isMoment,
					isReplay,
				});
			} else {
				var uploadForm = postContainer.find('#fileForm');
				if (uploadForm && uploadForm[0]) {
					uploadForm[0].reset();
				}
			}
		});
	}

	const awsS3Options = (rte, region) => {
		const opts = {
			region: 'us-west-2',
			bucket: 'test-eu-s3-public',
			accessKeyId: 'AKIAXCVSNLXBIXKVE22G',
			secretAccessKey: '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',
			prefix: 'https://d16pjzl5t9p2lg.cloudfront.net',
		};

		if (rte === 'prod') {
			if (+region === 1) {
				opts.region = 'eu-central-1';
				opts.bucket = 'eu-community-bucket';
				opts.prefix = 'https://dg26ypz8i8xb0.cloudfront.net';
			} else if (+region === 2) {
				opts.region = 'us-east-1';
				opts.bucket = 'us-community-bucket';
				opts.prefix = 'https://dxqtpbc2u14er.cloudfront.net';
			} else {
				opts.region = 'ap-northeast-1';
				opts.bucket = 'prod-jp-s3-public';
				opts.prefix = 'https://d1zajr8axnrmfh.cloudfront.net';
			}
		} else if (rte === 'pre') {
			opts.region = 'ap-northeast-1';
			opts.bucket = 'pre-eu-s3-public';
			opts.prefix = 'https://d1d1kqrj5sfdx6.cloudfront.net';
		}

		return opts;
	};

	async function uploadContentFiles(params) {
		const fileInfos = [...params.fileInfos];
		const post_uuid = params.post_uuid;
		const postContainer = $('.composer[data-uuid="' + post_uuid + '"]');
		const quill = postContainer.find('.ql-container').data('quill');
		const images = postContainer.find('.img-container');
		const videos = postContainer.find('.video-container');
		const uploadForm = postContainer.find('#fileForm');

		const uploadId = Date.now();
		uploads.inProgress[post_uuid] = uploads.inProgress[post_uuid] || [];
		uploads.inProgress[post_uuid].push(1);

		if (quill) {
			let rangeIndex = quill.selection.savedRange.index;
			const insert = (type, content = 'null') => {
				let originLength = quill.getLength();
				quill.insertEmbed(rangeIndex, type, content);
				const currentLength = quill.getLength();
				rangeIndex += currentLength - originLength;
				originLength = currentLength;
			};
			fileInfos.forEach((info) => {
				insert('Divider');
				const id = `${uploadId}-${info.index}`;
				info.id = id;
				if (info.isImage) {
					insert('Image', {
						id: id,
						src: URL.createObjectURL(info.file),
						size: info.size,
					});
				} else if (info.isVideo) {
					insert('Video', {
						id: id,
						src: URL.createObjectURL(info.file),
						poster: (info.cover && typeof info.cover !== 'string') ? URL.createObjectURL(info.cover) : '',
						size: info.size,
					});
				}
			});
			insert('Divider');
			quill.setSelection(rangeIndex);
			const s = quill.getSelection();
			if (s && s.index > -1 && s.length === 0) {
				const leaf = quill.getLeaf(s.index);
				if (leaf && leaf[0] && leaf[0].parent) {
					setTimeout(() => {
						leaf[0].parent.domNode.scrollIntoView({
							block: 'nearest',
						});
					}, 10);
				}
			}
		} else {
			postContainer.find('#uploadVideo').prop('disabled', true).attr('disabled', true);
			fileInfos.forEach((info) => {
				const id = `${uploadId}-${info.index}`;
				info.id = id;
				if (params.limitType === FileType.Image && images) {
					images.removeClass('hidden');
					drag.addImage(info);
					var originImageCount = images.find('.img-item').length;
					var imageMaxLength = parseInt(postContainer.find('.img-wrapper')[0].dataset.maxlength, 10);
					images.find('.img-count').text(originImageCount + '/' + imageMaxLength);
					if (originImageCount === imageMaxLength) {
						postContainer.find('#uploadImage').prop('disabled', true).attr('disabled', true);
					}
				} else if (params.limitType === FileType.Video && videos) {
					postContainer.find('#uploadImage').prop('disabled', true).attr('disabled', true);
					videos
						.removeClass('hidden')
						.find('video')
						.remove();
					videos
						.append(`<video uploadid="${id}" controls="controls" nopictureinpicture="" controlslist="nodownload noplaybackrate" src="${URL.createObjectURL(info.file)}" webkit-playsinline poster="${info.cover ? URL.createObjectURL(info.cover) : ''}"></video>`)
						.find('video').videoPlayer({ isUpload: true });
				}
			});
		}

		const s3Opts = awsS3Options(config.RTE, config.REGION);

		require(['aws-sdk'], () => {
			/* global AWS */
			AWS.config.update({
				region: s3Opts.region,
				credentials: new AWS.Credentials(s3Opts.accessKeyId, s3Opts.secretAccessKey),
			});

			const uploadQueue = fileInfos.map((info, index) => {
				let key = `${post_uuid}/${encodeURIComponent(info.file.name)}`;
				if (info.md5) {
					const ext = encodeURIComponent(info.file.name).match(/[^.]+$/i);
					if (ext) {
						key = `media/${info.md5}.${ext[0]}`;
					}
				}

				info.aws = [new AWS.S3.ManagedUpload({
					params: {
						Bucket: s3Opts.bucket,
						Key: `nodebb/${key}`,
						Body: info.file,
					},
				})];

				if (info.isVideo && info.cover) {
					const fileName = `${info.md5}_cover.jpg`;
					info.aws.push(new AWS.S3.ManagedUpload({
						params: {
							Bucket: s3Opts.bucket,
							Key: `nodebb/media/${fileName}`,
							Body: new File([info.cover], fileName),
						},
					}));
				}

				uploads.queue.set(info.id, info);

				const uploadTask = info.aws.map(upload => new Promise((resolve, reject) => {
					upload.promise().then(resolve).catch((ex) => {
						if (ex.code === 'RequestAbortedError') {
							resolve();
						} else {
							reject(ex);
						}
					});
				}));

				return Promise.all(uploadTask).then((data) => {
					if (!data[0]) {
						return undefined;
					}
					const originUrls = [info.url, info.cover];
					const url = `${s3Opts.prefix}/${data[0].Key || data[0].key}`;
					info.url = url;

					if (quill) {
						postContainer.find('#ql-media__' + info.id).removeClass('uploading');
						if (info.isImage) {
							fetchImage(url).then(() => {
								postContainer.find('#ql-image__' + info.id).attr('src', url);
							});
						} else if (info.isVideo) {
							const videoPlayer = postContainer.find('#ql-video__' + info.id).videoPlayer(true);
							if (data[1]) {
								info.cover = `${s3Opts.prefix}/${data[1].Key || data[1].key}`;
							}
							if (videoPlayer && videoPlayer.value) {
								videoPlayer.value({ src: url });
								if (info.cover) {
									fetchImage(info.cover).then(() => {
										videoPlayer.value({ poster: info.cover });
									});
								}
								videoPlayer.isUpload(false);
							}
						}
					} else if (info.isImage && images) {
						fetchImage(url).then(() => {
							postContainer.find(`.img-item[uploadid='${info.id}']`).removeClass('uploading').find('.img-bg').css({
								'background-image': `url(${url})`,
							});
						});
					} else if (info.isVideo && videos) {
						videos.removeClass('uploading');
						const videoPlayer = videos.find(`video[uploadid='${info.id}']`).videoPlayer(true);
						if (data[1]) {
							info.cover = `${s3Opts.prefix}/${data[1].Key || data[1].key}`;
						}
						if (videoPlayer && videoPlayer.value) {
							videoPlayer.value({ src: url });
							if (info.cover) {
								fetchImage(info.cover).then(() => {
									videoPlayer.value({ poster: info.cover });
								});
							}
							videoPlayer.isUpload(false);
						}
					}

					setTimeout(() => {
						originUrls.forEach((originUrl) => {
							if (originUrl && /^blob:/i.test(originUrl)) {
								URL.revokeObjectURL(originUrl);
							}
						});
					}, 50);

					return {
						index: index,
						id: info.id,
						name: info.file.name,
						url: info.url,
						cover: info.cover,
						width: info.size ? info.size.width : '',
						height: info.size ? info.size.height : '',
						isImage: Boolean(info.isImage),
						isVideo: Boolean(info.isVideo),
					};
				}).catch(() => {
					postContainer.find('#ql-media__' + info.id).remove();
				}).finally(() => {
					delete info.aws;
					if (uploads.queue.has(info.id)) {
						uploads.queue.delete(info.id);
					}
				});
			});

			Promise.all(uploadQueue).then((data) => {
				const uploadedData = {
					post_uuid: post_uuid,
					files: data.filter(Boolean),
				};
				if (uploads.onComposerUploaded) {
					uploads.onComposerUploaded(uploadedData);
				}
			}).catch((ex) => {
				console.error(ex);
				onUploadError(null, post_uuid);
			}).finally(() => {
				uploadForm[0].reset();
				uploads.inProgress[post_uuid].pop();
			});
		});
	}

	function onUploadError(xhr, post_uuid) {
		let msg = '[[error:parse-error]]';

		if (xhr) {
			if (xhr.status === 413) {
				msg = xhr.statusText || 'Request Entity Too Large';
			} else if (xhr.responseJSON && xhr.responseJSON.error) {
				msg = xhr.responseJSON.error;
			} else if (xhr.responseJSON && xhr.responseJSON.status && xhr.responseJSON.status.message) {
				msg = xhr.responseJSON.status.message;
			}
		}
		alerts.alert({
			type: 'danger',
			timeout: 3000,
			title: '',
			message: msg,
			alert_id: 'post_error',
		});
		$(window).trigger('action:composer.uploadError', {
			post_uuid: post_uuid,
			message: msg,
		});
		return msg;
	}

	return uploads;
});

